import gql from 'graphql-tag';

import integrationThreadFragment from '../fragments/integrationThreadFragment';

export default gql`
  query integrationThread(
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    integrationThread(
      integrationID: $integrationID
      remoteID: $remoteID
    ) {
      ...integrationThreadFragment
    }
  }
  ${integrationThreadFragment}
`;
